import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface AnnouncementItem {
  id: string;
  content: string;
  timeAgo: string;
}

interface SiteAnnouncementsProps {
  items?: AnnouncementItem[];
  isLoading?: boolean;
}

export function SiteAnnouncements({ items, isLoading }: SiteAnnouncementsProps) {
  const defaultItems: AnnouncementItem[] = [
    { 
      id: '1', 
      content: 'Họp giao ban tổ thi công vào 07:00 sáng mai (16/05/2024) tại lán trại công trường.', 
      timeAgo: '2 giờ trước' 
    },
  ];

  const displayItems = items || defaultItems;

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Thông báo</h3>

        <div className="flex-1 space-y-4">
          {displayItems.map((item) => (
            <div key={item.id} className="flex gap-3">
              <div className="w-8 h-8 rounded-full bg-orange-50 flex items-center justify-center shrink-0">
                <i className="ri-notification-3-line text-orange-500 text-sm" />
              </div>
              <div className="flex justify-between items-start gap-4 flex-1">
                <p className="text-xs text-slate-600 leading-normal font-medium">
                  {item.content}
                </p>
                <span className="text-[10px] font-bold text-slate-400 whitespace-nowrap">{item.timeAgo}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-emerald-600 flex items-center gap-2 hover:underline">
            <i className="ri-file-list-3-line text-sm" />
            Xem tất cả thông báo
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
